module.exports = __webpack_public_path__ + "img/thumb_404.2e225d23.png";